import axios from 'axios'
const INDICATORS_URL = process.env.INDICATORS_URL
const token = localStorage.getItem('heimdall-session-token')
const client = axios.create({
  baseURL: INDICATORS_URL,
  headers: { 'Authorization': token ? `Bearer ${token}` : null }
})

async function fetchIndicators ({ vehicleId, mark, reference, startDate, finishDate }) {
  const path = `/indicators/${mark}/${reference}/${vehicleId}/${startDate}/${finishDate}`
  let response
  try {
    response = await client.get(path)
  } catch (e) {
    console.error(e)
    return []
  }
  return response.data
}

async function downloadSpreadsheet ({ vehicleId, startDate, finishDate }) {
  const path = `/files/spreadsheet/download/${vehicleId}/${startDate}/${finishDate}`
  let response
  try {
    response = await client.get(path)
  } catch (e) {
    console.error(e)
    return null
  }
  const mime = response.headers['content-type'].split(';')[0] || 'application/octet-stream'
  const filename = response.headers['content-disposition'].split('=')[1] || 'reporte.xlsx'
  return {
    data: response.data,
    mime,
    filename
  }
}

async function downloadCsv ({ vehicleId, startDate, finishDate }) {
  const path = `/files/csv/download/${vehicleId}/${startDate}/${finishDate}`
  let response
  try {
    response = await client.get(path)
  } catch (e) {
    console.error(e)
    return null
  }
  const mime = response.headers['content-type'].split(';')[0] || 'application/octet-stream'
  const filename = response.headers['content-disposition'].split('=')[1] || 'reporte.csv'
  return {
    data: response.data,
    mime,
    filename
  }
}

export default {
  fetchIndicators,
  downloadSpreadsheet,
  downloadCsv
}



// WEBPACK FOOTER //
// ./src/api/indicators.js